<template>
  <div class="primary-feature">
    <!--    头部 banner  和  主标题-->
    <div class="head">
      <!--      背景banner-->
      <img class="head-banner" src="./images/chineseImages/banner.svg" />
    </div>

    <div class="details">
      <img src="./images/chineseImages/xqjs.svg" />
      <div class="left-title">
        紧扣阅读要素，总结方法技巧 掌握阅读秘籍，提高阅读成绩
      </div>
      <div class="right-title">
        详解作文技法，甄选素材美文 突破作文壁垒，提升写作能力
      </div>
      <div></div>
    </div>

    <!--    阅读理解专项-->
    <div id="div1" class="reading-comprehension-specialization">
      <div class="content">
        <div class="title">
          <div class="main-title">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="28"
              viewBox="0 0 48 28"
              fill="none"
            >
              <path
                d="M5.51357 5.96422C6.32631 4.84806 6.08035 3.28437 4.96419 2.47163C3.84803 1.65888 2.28434 1.90486 1.4716 3.02101C0.658856 4.13717 0.904827 5.70085 2.02099 6.5136C3.13715 7.32634 4.70083 7.08038 5.51357 5.96422Z"
                fill="#C7EB97"
              />
              <path
                d="M35.5 26C42.4036 26 48 20.4036 48 13.5C48 6.59644 42.4036 1 35.5 1C28.5964 1 23 6.59644 23 13.5C23 20.4036 28.5964 26 35.5 26Z"
                fill="url(#paint0_linear_3816_13519)"
              />
              <path
                d="M33.0543 19.8864C36.3053 15.4218 35.3214 9.16702 30.8568 5.91604C26.3921 2.66506 20.1374 3.64896 16.8864 8.11359C13.6354 12.5782 14.6193 18.8329 19.0839 22.0839C23.5486 25.3349 29.8033 24.3511 33.0543 19.8864Z"
                fill="url(#paint1_linear_3816_13519)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M28.0279 23.5218C29.9788 22.8971 31.7561 21.6693 33.0543 19.8864C36.3053 15.4218 35.3214 9.16705 30.8568 5.91607C29.7015 5.07483 28.4263 4.51716 27.1144 4.22998C24.5875 6.51723 23 9.82324 23 13.5C23 17.6021 24.9759 21.2426 28.0279 23.5218Z"
                fill="url(#paint2_linear_3816_13519)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_3816_13519"
                  x1="33.5"
                  y1="30"
                  x2="50"
                  y2="1"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#77DFC8" />
                  <stop offset="1" stop-color="#79E0C8" stop-opacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_3816_13519"
                  x1="16.8864"
                  y1="8.11357"
                  x2="33.0543"
                  y2="19.8864"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.25" stop-color="#DBF7B6" />
                  <stop offset="1" stop-color="white" stop-opacity="0.74" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_3816_13519"
                  x1="21.5"
                  y1="14.0001"
                  x2="36"
                  y2="15.5001"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#DBF7B6" />
                  <stop offset="1" stop-color="#78DFC8" />
                </linearGradient>
              </defs>
            </svg>
            阅读理解专项
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="28"
              viewBox="0 0 48 28"
              fill="none"
            >
              <path
                d="M42.4864 22.0358C41.6737 23.1519 41.9196 24.7156 43.0358 25.5284C44.152 26.3411 45.7157 26.0951 46.5284 24.979C47.3411 23.8628 47.0952 22.2991 45.979 21.4864C44.8629 20.6737 43.2992 20.9196 42.4864 22.0358Z"
                fill="#78DFC8"
              />
              <path
                d="M12.5 2C5.59644 2 3.12076e-09 7.59644 2.01043e-09 14.5C9.00101e-10 21.4036 5.59644 27 12.5 27C19.4036 27 25 21.4036 25 14.5C25 7.59644 19.4036 2 12.5 2Z"
                fill="url(#paint0_linear_3816_13529)"
              />
              <path
                d="M14.9457 8.11358C11.6947 12.5782 12.6786 18.833 17.1432 22.084C21.6079 25.3349 27.8626 24.351 31.1136 19.8864C34.3646 15.4218 33.3807 9.16705 28.9161 5.91607C24.4514 2.6651 18.1967 3.64895 14.9457 8.11358Z"
                fill="url(#paint1_linear_3816_13529)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.9721 4.47816C18.0212 5.10288 16.2439 6.33068 14.9457 8.11355C11.6947 12.5782 12.6786 18.833 17.1432 22.0839C18.2985 22.9252 19.5737 23.4828 20.8856 23.77C23.4125 21.4828 25 18.1768 25 14.5C25 10.3979 23.0241 6.75735 19.9721 4.47816Z"
                fill="url(#paint2_linear_3816_13529)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_3816_13529"
                  x1="14.5"
                  y1="-2"
                  x2="-2"
                  y2="27"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#77DFC8" />
                  <stop offset="1" stop-color="#79E0C8" stop-opacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_3816_13529"
                  x1="31.1136"
                  y1="19.8864"
                  x2="14.9457"
                  y2="8.1136"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.25" stop-color="#DBF7B6" />
                  <stop offset="1" stop-color="white" stop-opacity="0.74" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_3816_13529"
                  x1="26.5"
                  y1="13.9999"
                  x2="12"
                  y2="12.4999"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#DBF7B6" />
                  <stop offset="1" stop-color="#78DFC8" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div class="sub-title">
            从课内到课外，紧跟阅读要素，总结方法技巧，全面提升阅读素养
          </div>
        </div>
        <div class="resource-list">
          <div class="top">
            <div
              class="resource"
              v-for="i in readingComprehensionSpecializationData"
              :key="i.id"
            >
              <div class="top-title">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="12"
                  viewBox="0 0 15 12"
                  fill="none"
                >
                  <rect
                    x="5.07544"
                    y="5.43701"
                    width="7"
                    height="7"
                    transform="rotate(-45 5.07544 5.43701)"
                    fill="#007A94"
                  />
                  <rect
                    y="8.4873"
                    width="4.2782"
                    height="4.2782"
                    transform="rotate(-45 0 8.4873)"
                    fill="#5DC5CC"
                  />
                </svg>
                {{ i.title }}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="12"
                  viewBox="0 0 16 12"
                  fill="none"
                >
                  <rect
                    x="0.974854"
                    y="5.46216"
                    width="7"
                    height="7"
                    transform="rotate(-45 0.974854 5.46216)"
                    fill="#007A94"
                  />
                  <rect
                    x="9.89941"
                    y="8.46216"
                    width="4.2782"
                    height="4.2782"
                    transform="rotate(-45 9.89941 8.46216)"
                    fill="#5DC5CC"
                  />
                </svg>
              </div>
              <div class="top-resource">
                <div
                  class="data"
                  v-for="j in i.resourceList"
                  :key="j.id"
                  data-io-click="tracker"  @click="toAlbumPage(j.id)"
                >
                  <img src="./images/chineseImages/group1648.svg" />
                  <div class="grade">{{ j.grade }}</div>
                  <div class="data-title">{{ j.title }}</div>
                  <div class="data-subtitle">{{ j.subtitle }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div data-io-click="tracker"  @click="toAlbumPage(3122427)">
              <img src="./images/chineseImages/group1642.svg" />
              <div class="bottom-title">快乐读书吧专项训练</div>
            </div>
            <div data-io-click="tracker"  @click="toAlbumPage(3054330)">
              <img src="./images/chineseImages/group1642.svg" />
              <div class="bottom-title">古诗词专项训练</div>
            </div>
            <div data-io-click="tracker"  @click="toAlbumPage(3056530)">
              <img src="./images/chineseImages/group1642.svg" />
              <div class="bottom-title">小古文专项训练</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    写作能力提升-->
    <div id="div2" class="improvement-of-writing-ability">
      <div class="content">
        <div class="title">
          <div class="main-title">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="28"
              viewBox="0 0 48 28"
              fill="none"
            >
              <path
                d="M5.51357 5.96422C6.32631 4.84806 6.08035 3.28437 4.96419 2.47163C3.84803 1.65888 2.28434 1.90486 1.4716 3.02101C0.658856 4.13717 0.904827 5.70085 2.02099 6.5136C3.13715 7.32634 4.70083 7.08038 5.51357 5.96422Z"
                fill="#C7EB97"
              />
              <path
                d="M35.5 26C42.4036 26 48 20.4036 48 13.5C48 6.59644 42.4036 1 35.5 1C28.5964 1 23 6.59644 23 13.5C23 20.4036 28.5964 26 35.5 26Z"
                fill="url(#paint0_linear_3816_13519)"
              />
              <path
                d="M33.0543 19.8864C36.3053 15.4218 35.3214 9.16702 30.8568 5.91604C26.3921 2.66506 20.1374 3.64896 16.8864 8.11359C13.6354 12.5782 14.6193 18.8329 19.0839 22.0839C23.5486 25.3349 29.8033 24.3511 33.0543 19.8864Z"
                fill="url(#paint1_linear_3816_13519)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M28.0279 23.5218C29.9788 22.8971 31.7561 21.6693 33.0543 19.8864C36.3053 15.4218 35.3214 9.16705 30.8568 5.91607C29.7015 5.07483 28.4263 4.51716 27.1144 4.22998C24.5875 6.51723 23 9.82324 23 13.5C23 17.6021 24.9759 21.2426 28.0279 23.5218Z"
                fill="url(#paint2_linear_3816_13519)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_3816_13519"
                  x1="33.5"
                  y1="30"
                  x2="50"
                  y2="1"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#77DFC8" />
                  <stop offset="1" stop-color="#79E0C8" stop-opacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_3816_13519"
                  x1="16.8864"
                  y1="8.11357"
                  x2="33.0543"
                  y2="19.8864"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.25" stop-color="#DBF7B6" />
                  <stop offset="1" stop-color="white" stop-opacity="0.74" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_3816_13519"
                  x1="21.5"
                  y1="14.0001"
                  x2="36"
                  y2="15.5001"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#DBF7B6" />
                  <stop offset="1" stop-color="#78DFC8" />
                </linearGradient>
              </defs>
            </svg>
            写作能力提升
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="28"
              viewBox="0 0 48 28"
              fill="none"
            >
              <path
                d="M42.4864 22.0358C41.6737 23.1519 41.9196 24.7156 43.0358 25.5284C44.152 26.3411 45.7157 26.0951 46.5284 24.979C47.3411 23.8628 47.0952 22.2991 45.979 21.4864C44.8629 20.6737 43.2992 20.9196 42.4864 22.0358Z"
                fill="#78DFC8"
              />
              <path
                d="M12.5 2C5.59644 2 3.12076e-09 7.59644 2.01043e-09 14.5C9.00101e-10 21.4036 5.59644 27 12.5 27C19.4036 27 25 21.4036 25 14.5C25 7.59644 19.4036 2 12.5 2Z"
                fill="url(#paint0_linear_3816_13529)"
              />
              <path
                d="M14.9457 8.11358C11.6947 12.5782 12.6786 18.833 17.1432 22.084C21.6079 25.3349 27.8626 24.351 31.1136 19.8864C34.3646 15.4218 33.3807 9.16705 28.9161 5.91607C24.4514 2.6651 18.1967 3.64895 14.9457 8.11358Z"
                fill="url(#paint1_linear_3816_13529)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.9721 4.47816C18.0212 5.10288 16.2439 6.33068 14.9457 8.11355C11.6947 12.5782 12.6786 18.833 17.1432 22.0839C18.2985 22.9252 19.5737 23.4828 20.8856 23.77C23.4125 21.4828 25 18.1768 25 14.5C25 10.3979 23.0241 6.75735 19.9721 4.47816Z"
                fill="url(#paint2_linear_3816_13529)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_3816_13529"
                  x1="14.5"
                  y1="-2"
                  x2="-2"
                  y2="27"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#77DFC8" />
                  <stop offset="1" stop-color="#79E0C8" stop-opacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_3816_13529"
                  x1="31.1136"
                  y1="19.8864"
                  x2="14.9457"
                  y2="8.1136"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.25" stop-color="#DBF7B6" />
                  <stop offset="1" stop-color="white" stop-opacity="0.74" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_3816_13529"
                  x1="26.5"
                  y1="13.9999"
                  x2="12"
                  y2="12.4999"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#DBF7B6" />
                  <stop offset="1" stop-color="#78DFC8" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div class="sub-title">
            针对不同类型的作文，详解作文思路技巧方法，同时匹配范文、点评、素材
          </div>
        </div>
        <div class="tabs">
          <div
            :class="
              improvementOfWritingAbilityTabId == 1 ? 'checked' : 'unchecked'
            "
            data-io-click="tracker"  @click="changeImprovementOfWritingAbilityTabId(1)"
          >
            单元作文能力提升
          </div>
          <div
            :class="
              improvementOfWritingAbilityTabId == 2 ? 'checked' : 'unchecked'
            "
            data-io-click="tracker"  @click="changeImprovementOfWritingAbilityTabId(2)"
            style="margin-left: 36px"
          >
            单元作文素材积累
          </div>
          <div
            :class="
              improvementOfWritingAbilityTabId == 3 ? 'checked' : 'unchecked'
            "
            data-io-click="tracker"  @click="changeImprovementOfWritingAbilityTabId(3)"
            style="margin-left: 36px"
          >
            单元作文范文点评
          </div>
          <div
            :class="
              improvementOfWritingAbilityTabId == 4 ? 'checked' : 'unchecked'
            "
            data-io-click="tracker"  @click="changeImprovementOfWritingAbilityTabId(4)"
            style="margin-left: 36px; width: 168px"
          >
            作文主题训练
          </div>
          <div
            :class="
              improvementOfWritingAbilityTabId == 5 ? 'checked' : 'unchecked'
            "
            data-io-click="tracker"  @click="changeImprovementOfWritingAbilityTabId(5)"
            style="margin-left: 36px; width: 168px"
          >
            作文分类指导
          </div>
        </div>
        <div class="resource-list">
          <div class="resource-content">
            <div
              class="resource"
              v-for="i in improvementOfWritingAbilityData"
              :key="i.id"
              data-io-click="tracker"  @click="toAlbumPage(i.id)"
            >
              <img
                v-if="improvementOfWritingAbilityTabId == 1"
                src="./images/chineseImages/group777.svg"
              />
              <div
                v-if="improvementOfWritingAbilityTabId == 1"
                class="resource-title"
              >
                {{ i.title }}
              </div>
              <div
                v-if="improvementOfWritingAbilityTabId == 1"
                class="resource-subtitle"
              >
                {{ i.subtitle }}
              </div>

              <img
                v-if="improvementOfWritingAbilityTabId == 2"
                src="./images/chineseImages/xz2.png"
              />
              <div
                style="color: #007a94"
                v-if="improvementOfWritingAbilityTabId == 2"
                class="resource-title"
              >
                {{ i.title }}
              </div>
              <div
                style="color: #007a94"
                v-if="improvementOfWritingAbilityTabId == 2"
                class="resource-subtitle"
              >
                {{ i.subtitle }}
              </div>

              <img
                v-if="improvementOfWritingAbilityTabId == 3"
                src="./images/chineseImages/xz3.png"
              />
              <div
                style="color: #044f9c"
                v-if="improvementOfWritingAbilityTabId == 3"
                class="resource-title"
              >
                {{ i.title }}
              </div>
              <div
                style="color: #044f9c"
                v-if="improvementOfWritingAbilityTabId == 3"
                class="resource-subtitle"
              >
                {{ i.subtitle }}
              </div>

              <img
                v-if="improvementOfWritingAbilityTabId == 4"
                src="./images/chineseImages/xz4.png"
              />
              <div
                style="color: #007a94"
                v-if="improvementOfWritingAbilityTabId == 4"
                class="resource-title"
              >
                {{ i.title }}
              </div>
              <div
                style="color: #007a94"
                v-if="improvementOfWritingAbilityTabId == 4"
                class="resource-subtitle"
              >
                {{ i.subtitle }}
              </div>
              <div
                v-if="
                  improvementOfWritingAbilityTabId !== 1 &&
                  improvementOfWritingAbilityTabId !== 5
                "
                class="to-see"
              >
                点击查看
              </div>

              <img
                v-if="improvementOfWritingAbilityTabId == 5"
                src="./images/chineseImages/xz5.png"
              />
              <div
                style="color: #044f9c"
                v-if="improvementOfWritingAbilityTabId == 5"
                class="resource-title"
              >
                {{ i.title }}
              </div>
              <div
                style="color: #044f9c"
                v-if="improvementOfWritingAbilityTabId == 5"
                class="resource-subtitle"
              >
                {{ i.subtitle }}
              </div>
              <div
                style="background: #044f9c"
                v-if="improvementOfWritingAbilityTabId == 5"
                class="to-see"
              >
                点击查看
              </div>

              <div class="resource-subscript">{{ i.subscriptTitle }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    生字、古诗词默写-->
    <div id="div3" class="silent-writing-ancient-poetry">
      <div class="content">
        <div class="title">
          <div class="main-title">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="28"
              viewBox="0 0 48 28"
              fill="none"
            >
              <path
                d="M5.51357 5.96422C6.32631 4.84806 6.08035 3.28437 4.96419 2.47163C3.84803 1.65888 2.28434 1.90486 1.4716 3.02101C0.658856 4.13717 0.904827 5.70085 2.02099 6.5136C3.13715 7.32634 4.70083 7.08038 5.51357 5.96422Z"
                fill="#C7EB97"
              />
              <path
                d="M35.5 26C42.4036 26 48 20.4036 48 13.5C48 6.59644 42.4036 1 35.5 1C28.5964 1 23 6.59644 23 13.5C23 20.4036 28.5964 26 35.5 26Z"
                fill="url(#paint0_linear_3816_13519)"
              />
              <path
                d="M33.0543 19.8864C36.3053 15.4218 35.3214 9.16702 30.8568 5.91604C26.3921 2.66506 20.1374 3.64896 16.8864 8.11359C13.6354 12.5782 14.6193 18.8329 19.0839 22.0839C23.5486 25.3349 29.8033 24.3511 33.0543 19.8864Z"
                fill="url(#paint1_linear_3816_13519)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M28.0279 23.5218C29.9788 22.8971 31.7561 21.6693 33.0543 19.8864C36.3053 15.4218 35.3214 9.16705 30.8568 5.91607C29.7015 5.07483 28.4263 4.51716 27.1144 4.22998C24.5875 6.51723 23 9.82324 23 13.5C23 17.6021 24.9759 21.2426 28.0279 23.5218Z"
                fill="url(#paint2_linear_3816_13519)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_3816_13519"
                  x1="33.5"
                  y1="30"
                  x2="50"
                  y2="1"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#77DFC8" />
                  <stop offset="1" stop-color="#79E0C8" stop-opacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_3816_13519"
                  x1="16.8864"
                  y1="8.11357"
                  x2="33.0543"
                  y2="19.8864"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.25" stop-color="#DBF7B6" />
                  <stop offset="1" stop-color="white" stop-opacity="0.74" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_3816_13519"
                  x1="21.5"
                  y1="14.0001"
                  x2="36"
                  y2="15.5001"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#DBF7B6" />
                  <stop offset="1" stop-color="#78DFC8" />
                </linearGradient>
              </defs>
            </svg>
            生字&古诗词默写
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="28"
              viewBox="0 0 48 28"
              fill="none"
            >
              <path
                d="M42.4864 22.0358C41.6737 23.1519 41.9196 24.7156 43.0358 25.5284C44.152 26.3411 45.7157 26.0951 46.5284 24.979C47.3411 23.8628 47.0952 22.2991 45.979 21.4864C44.8629 20.6737 43.2992 20.9196 42.4864 22.0358Z"
                fill="#78DFC8"
              />
              <path
                d="M12.5 2C5.59644 2 3.12076e-09 7.59644 2.01043e-09 14.5C9.00101e-10 21.4036 5.59644 27 12.5 27C19.4036 27 25 21.4036 25 14.5C25 7.59644 19.4036 2 12.5 2Z"
                fill="url(#paint0_linear_3816_13529)"
              />
              <path
                d="M14.9457 8.11358C11.6947 12.5782 12.6786 18.833 17.1432 22.084C21.6079 25.3349 27.8626 24.351 31.1136 19.8864C34.3646 15.4218 33.3807 9.16705 28.9161 5.91607C24.4514 2.6651 18.1967 3.64895 14.9457 8.11358Z"
                fill="url(#paint1_linear_3816_13529)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.9721 4.47816C18.0212 5.10288 16.2439 6.33068 14.9457 8.11355C11.6947 12.5782 12.6786 18.833 17.1432 22.0839C18.2985 22.9252 19.5737 23.4828 20.8856 23.77C23.4125 21.4828 25 18.1768 25 14.5C25 10.3979 23.0241 6.75735 19.9721 4.47816Z"
                fill="url(#paint2_linear_3816_13529)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_3816_13529"
                  x1="14.5"
                  y1="-2"
                  x2="-2"
                  y2="27"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#77DFC8" />
                  <stop offset="1" stop-color="#79E0C8" stop-opacity="0" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_3816_13529"
                  x1="31.1136"
                  y1="19.8864"
                  x2="14.9457"
                  y2="8.1136"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.25" stop-color="#DBF7B6" />
                  <stop offset="1" stop-color="white" stop-opacity="0.74" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_3816_13529"
                  x1="26.5"
                  y1="13.9999"
                  x2="12"
                  y2="12.4999"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#DBF7B6" />
                  <stop offset="1" stop-color="#78DFC8" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div class="sub-title">
            精心梳理课文生字和古诗默写，适合期中期末备考复习
          </div>
        </div>
        <div class="resource-list">
          <div class="resource-content">
            <div
              class="resource"
              v-for="i in silentWritingAncientPoetryData"
              :key="i.id"
              data-io-click="tracker"  @click="toAlbumPage(i.id)"
            >
              <img src="./images/chineseImages/group16421.svg" />
              <div class="resource-title">{{ i.title }}</div>
              <div class="resource-subtitle">{{ i.subtitle }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    侧边导航-->
    <div class="side">
      <a href="#div1"
        ><div
          data-io-click="tracker"  @click="changeSide(1)"
          :class="{ 'side-checked': checkSideId == 1 }"
          class="title-1"
        >
          阅读理解专项
        </div></a
      >
      <a href="#div2"
        ><div
          data-io-click="tracker"  @click="changeSide(2)"
          :class="{ 'side-checked': checkSideId == 2 }"
          class="title-2"
        >
          写作能力提升
        </div></a
      >
      <a href="#div3"
        ><div
          data-io-click="tracker"  @click="changeSide(3)"
          :class="{ 'side-checked': checkSideId == 3 }"
          class="title-3"
        >
          生字&古诗词默写
        </div></a
      >
      <img class="bar" src="./images/chineseImages/sidebar.svg" />
      <a href="#top"
        ><img class="back" src="./images/chineseImages/backTop.svg"
      /></a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      checkSideId: 1,
      improvementOfWritingAbilityTabId: 1,
      readingComprehensionSpecializationData: [
        {
          id: 1,
          title: "类文阅读",
          resourceList: [
            {
              id: 3297215,
              grade: "三年级",
              title: "课文类文阅读理解",
              subtitle: "阅读要素，类文训练",
            },
            {
              id: 3297216,
              grade: "四年级",
              title: "课文类文阅读理解",
              subtitle: "阅读要素，类文训练",
            },
            {
              id: 3297214,
              grade: "五年级",
              title: "课文类文阅读理解",
              subtitle: "阅读要素，类文训练",
            },
            {
              id: 3297213,
              grade: "六年级",
              title: "课文类文阅读理解",
              subtitle: "阅读要素，类文训练",
            },
          ],
        },
        {
          id: 2,
          title: "单元主题阅读",
          resourceList: [
            {
              id: 3297200,
              grade: "三年级",
              title: "单元主题阅读理解",
              subtitle: "主题阅读，方法提炼",
            },
            {
              id: 3297198,
              grade: "四年级",
              title: "单元主题阅读理解",
              subtitle: "主题阅读，方法提炼",
            },
            {
              id: 3297197,
              grade: "五年级",
              title: "单元主题阅读理解",
              subtitle: "主题阅读，方法提炼",
            },
            {
              id: 3297193,
              grade: "六年级",
              title: "单元主题阅读理解",
              subtitle: "主题阅读，方法提炼",
            },
          ],
        },
        {
          id: 3,
          title: "现代文阅读",
          resourceList: [
            {
              id: 3034385,
              grade: "三年级",
              title: "语文阅读专项训练",
              subtitle: "高频考点，讲练结合",
            },
            {
              id: 3034388,
              grade: "四年级",
              title: "语文阅读专项训练",
              subtitle: "高频考点，讲练结合",
            },
            {
              id: 3034389,
              grade: "五年级",
              title: "语文阅读专项训练",
              subtitle: "高频考点，讲练结合",
            },
            {
              id: 3034390,
              grade: "六年级",
              title: "语文阅读专项训练",
              subtitle: "高频考点，讲练结合",
            },
          ],
        },
      ],
      improvementOfWritingAbilityDataOne: [
        {
          id: 3290600,
          title: "一年级语文上册",
          subtitle: "单元写话能力提升",
          subscriptTitle: "技法+作文+素材",
        },
        {
          id: 3290599,
          title: "二年级语文上册",
          subtitle: "单元写话能力提升",
          subscriptTitle: "技法+范文+素材",
        },
        {
          id: 3290598,
          title: "三年级语文上册",
          subtitle: "单元写作能力提升",
          subscriptTitle: "技法+范文+素材",
        },
        {
          id: 3290597,
          title: "四年级语文上册",
          subtitle: "单元写作能力提升",
          subscriptTitle: "技法+范文+素材",
        },
        {
          id: 3290596,
          title: "五年级语文上册",
          subtitle: "单元写作能力提升",
          subscriptTitle: "技法+范文+素材",
        },
        {
          id: 3290595,
          title: "六年级语文上册",
          subtitle: "单元写作能力提升",
          subscriptTitle: "技法+范文+素材",
        },
      ],
      improvementOfWritingAbilityDataTwo: [
        {
          id: 3293152,
          title: "一年级语文上册",
          subtitle: "看图写话素材积累",
          subscriptTitle: "写话公式",
        },
        {
          id: 3293151,
          title: "二年级语文上册",
          subtitle: "看图写话素材积累",
          subscriptTitle: "写话公式",
        },
        {
          id: 3293153,
          title: "三年级语文上册",
          subtitle: "单元作文素材积累",
          subscriptTitle: "词句段积累",
        },
        {
          id: 3293154,
          title: "四年级语文上册",
          subtitle: "单元作文素材积累",
          subscriptTitle: "词句段积累",
        },
        {
          id: 3293155,
          title: "五年级语文上册",
          subtitle: "单元作文素材积累",
          subscriptTitle: "词句段积累",
        },
        {
          id: 3293156,
          title: "六年级语文上册",
          subtitle: "单元作文素材积累",
          subscriptTitle: "词句段积累",
        },
      ],
      improvementOfWritingAbilityDataThree: [
        {
          id: 3293164,
          title: "三年级语文上册",
          subtitle: "单元作文范文点评",
          subscriptTitle: "好词好句+写作指导",
        },
        {
          id: 3293166,
          title: "四年级语文上册",
          subtitle: "单元作文范文点评",
          subscriptTitle: "好词好句+写作指导",
        },
        {
          id: 3293167,
          title: "五年级语文上册",
          subtitle: "单元作文范文点评",
          subscriptTitle: "好词好句+写作指导",
        },
        {
          id: 3293168,
          title: "六年级语文上册",
          subtitle: "单元作文范文点评",
          subscriptTitle: "好词好句+写作指导",
        },
      ],
      improvementOfWritingAbilityDataFour: [
        {
          id: 3050197,
          title: "三年级语文上册",
          subtitle: "作文主题训练课件",
          subscriptTitle: "技法+真题+范文",
        },
        {
          id: 3050200,
          title: "四年级语文上册",
          subtitle: "作文主题训练课件",
          subscriptTitle: "技法+真题+范文",
        },
        {
          id: 3050201,
          title: "五年级语文上册",
          subtitle: "作文主题训练课件",
          subscriptTitle: "技法+真题+范文",
        },
        {
          id: 3050220,
          title: "六年级语文上册",
          subtitle: "作文主题训练课件",
          subscriptTitle: "技法+真题+范文",
        },
        {
          id: 3028378,
          title: "小升初语文",
          subtitle: "作文主题训练课件",
          subscriptTitle: "技法+真题+范文",
        },
      ],
      improvementOfWritingAbilityDataFive: [
        {
          id: 39519339,
          title: "写人类作文",
          subtitle: "小学语文分类指导",
          subscriptTitle: "习作归类及指导",
        },
        {
          id: 39587010,
          title: "记事类作文",
          subtitle: "小学语文分类指导",
          subscriptTitle: "习作归类及指导",
        },
        {
          id: 39690724,
          title: "写景类作文",
          subtitle: "小学语文分类指导",
          subscriptTitle: "习作归类及指导",
        },
        {
          id: 39721873,
          title: "写状物类作文",
          subtitle: "小学语文分类指导",
          subscriptTitle: "习作归类及指导",
        },
        {
          id: 39811686,
          title: "写想象类作文",
          subtitle: "小学语文分类指导",
          subscriptTitle: "习作归类及指导",
        },
        {
          id: 3041339,
          title: "小学语文作文",
          subtitle: "小学语文分类指导",
          subscriptTitle: "习作归类及指导",
        },
      ],
      improvementOfWritingAbilityData: [
        {
          id: 3290600,
          title: "一年级语文上册",
          subtitle: "单元写话能力提升",
          subscriptTitle: "技法+作文+素材",
        },
        {
          id: 3290599,
          title: "二年级语文上册",
          subtitle: "单元写话能力提升",
          subscriptTitle: "技法+范文+素材",
        },
        {
          id: 3290598,
          title: "三年级语文上册",
          subtitle: "单元写作能力提升",
          subscriptTitle: "技法+范文+素材",
        },
        {
          id: 3290597,
          title: "四年级语文上册",
          subtitle: "单元写作能力提升",
          subscriptTitle: "技法+范文+素材",
        },
        {
          id: 3290596,
          title: "五年级语文上册",
          subtitle: "单元写作能力提升",
          subscriptTitle: "技法+范文+素材",
        },
        {
          id: 3290595,
          title: "六年级语文上册",
          subtitle: "单元写作能力提升",
          subscriptTitle: "技法+范文+素材",
        },
      ],
      silentWritingAncientPoetryData: [
        { id: 3293101, title: "一年级语文上册", subtitle: "生字古诗+练习" },
        { id: 3293041, title: "二年级语文上册", subtitle: "生字古诗+练习" },
        { id: 3293093, title: "三年级语文上册", subtitle: "生字古诗+练习" },
        { id: 3293097, title: "四年级语文上册", subtitle: "生字古诗+练习" },
        { id: 3293098, title: "五年级语文上册", subtitle: "生字古诗+练习" },
        { id: 3293099, title: "六年级语文上册", subtitle: "生字古诗+练习" },
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    toResourcePage(resourceId) {
      //新页面跳转
      window.open(`https://wxt.xkw.com/soft/${resourceId}-1.html`);
    },
    toAlbumPage(resourceId) {
      if (
        [39519339, 39587010, 39690724, 39721873, 39811686].includes(resourceId)
      ) {
        this.toResourcePage(resourceId);
        return;
      }
      //新页面跳转
      window.open(`https://wxt.xkw.com/docpack/${resourceId}.html`);
    },
    changeImprovementOfWritingAbilityTabId(tabId) {
      this.improvementOfWritingAbilityTabId = tabId;
      if (tabId == 1) {
        this.improvementOfWritingAbilityData =
          this.improvementOfWritingAbilityDataOne;
      } else if (tabId == 2) {
        this.improvementOfWritingAbilityData =
          this.improvementOfWritingAbilityDataTwo;
      } else if (tabId == 3) {
        this.improvementOfWritingAbilityData =
          this.improvementOfWritingAbilityDataThree;
      } else if (tabId == 4) {
        this.improvementOfWritingAbilityData =
          this.improvementOfWritingAbilityDataFour;
      } else {
        this.improvementOfWritingAbilityData =
          this.improvementOfWritingAbilityDataFive;
      }
    },
    changeSide(id) {
      this.checkSideId = id;
    },
    onScroll() {
      const sections = [
        { id: 1, offset: document.querySelector("#div1").offsetTop },
        { id: 2, offset: document.querySelector("#div2").offsetTop },
        { id: 3, offset: document.querySelector("#div3").offsetTop },
      ];

      const scrollPosition = window.scrollY + window.innerHeight / 2;

      for (let i = sections.length - 1; i >= 0; i--) {
        if (scrollPosition >= sections[i].offset) {
          this.checkSideId = sections[i].id;
          break;
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.primary-feature {
  background: #e1f8ff;
}
.head {
  //position: relative;
  //height: 380px;
  //width: 100%;

  .head-banner {
    width: 100%;
    height: 100%;
  }
}

.details {
  width: 1194px;
  height: 150px;
  margin: 0px auto;
  position: relative;

  .left-title {
    color: #000;
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px; /* 168.75% */
    width: 220px;
    height: 54px;
    position: absolute;
    bottom: 30px;
    left: 244px;
  }

  .right-title {
    color: #000;
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px; /* 168.75% */

    width: 220px;
    height: 54px;
    position: absolute;
    bottom: 29px;
    left: 822px;
  }
}

.reading-comprehension-specialization {
  background: #e1f8ff;
  height: 920px;
  width: 100%;
  position: relative;

  .content {
    width: 1194px;
    height: 800px;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;

    .title {
      width: 464px;
      height: 72px;
      flex-shrink: 0;
      margin: 0px auto 0px;
      text-align: center;

      .main-title {
        color: #007a94;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 36px;
        font-style: normal;
        font-weight: 600;
        line-height: 36px; /* 100% */
      }

      .sub-title {
        margin-top: 20px;
        color: #000;
        font-family: "PingFang SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px; /* 100% */
      }
    }

    .resource-list {
      width: 1194px;
      height: 692px;
      flex-shrink: 0;
      background-color: #fff;
      border-radius: 20px;
      margin: 30px auto 60px;
      box-shadow: 0px 4px 4px 0px rgba(225, 196, 124, 0.5);
      position: relative;
      padding-top: 60px;

      .top {
        padding-left: 30px;
        width: 1150px;
        height: 414px;

        .resource {
          height: 414px;
          width: 338px;
          margin-left: 30px;
          border-radius: 14px;
          background: #e4ffe7;
          display: inline-block;

          .top-title {
            margin: 20px auto 10px;
            color: #007a94;
            font-family: "PingFang SC";
            font-size: 22px;
            font-style: normal;
            font-weight: 600;
            line-height: 22px; /* 100% */
            text-align: center;
          }

          .top-resource {
            .data {
              margin-top: 10px;
              margin-left: 10px;
              height: 165px;
              width: 154px;
              display: inline-block;
              position: relative;
              transition: all 0.3s;

              .grade {
                color: #fff;
                text-align: center;
                font-family: "Alibaba PuHuiTi";
                font-size: 18px;
                font-style: normal;
                font-weight: 400;
                line-height: 30px; /* 166.667% */

                position: absolute;
                bottom: 136px;
                left: 49px;
              }

              .data-title {
                color: #007a94;
                text-align: center;
                font-family: "Alibaba PuHuiTi";
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 18px; /* 112.5% */

                position: absolute;
                bottom: 110px;
                left: 11px;
              }

              .data-subtitle {
                color: #007a94;
                text-align: center;
                font-family: "Alibaba PuHuiTi";
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 16px; /* 114.286% */

                position: absolute;
                bottom: 11px;
                left: 14px;
              }

              &:hover {
                cursor: pointer;
                transform: translateY(-10px);
              }
            }
          }
        }
      }

      .bottom {
        margin-top: 30px;
        padding-left: 30px;
        div {
          width: 338px;
          height: 128px;
          display: inline-block;
          margin-left: 30px;
          position: relative;

          transition: all 0.3s;
          &:hover {
            cursor: pointer;
            transform: translateY(-10px);
          }
        }

        .bottom-title {
          position: absolute;
          top: 27px;
          left: 0px;

          color: #007a94;
          font-family: "PingFang SC";
          font-size: 20px;
          font-style: normal;
          font-weight: 600;
          line-height: 22px; /* 110% */
        }
      }
    }
  }
}

.improvement-of-writing-ability {
  background: #d6f0fe;
  height: 704px;
  width: 100%;
  position: relative;

  .content {
    width: 1194px;
    height: 584px;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;

    .title {
      width: 550px;
      height: 72px;
      flex-shrink: 0;
      margin: 0px auto 0px;
      text-align: center;

      .main-title {
        color: #007a94;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 36px;
        font-style: normal;
        font-weight: 600;
        line-height: 36px; /* 100% */
      }

      .sub-title {
        margin-top: 20px;
        color: #000;
        font-family: "PingFang SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px; /* 100% */
      }
    }

    .tabs {
      margin-top: 20px;
      margin-left: 57px;

      div {
        display: inline-block;
        width: 200px;
        height: 38px;
        border-radius: 100px;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 38px;
      }
    }

    .resource-list {
      width: 1194px;
      height: 418px;
      flex-shrink: 0;
      background-color: #fff;
      border-radius: 20px;
      margin: 30px auto 60px;
      box-shadow: 0px 4px 4px 0px rgba(225, 196, 124, 0.5);
      position: relative;

      .resource-content {
        padding-left: 27px;
        padding-top: 30px;

        .resource {
          position: relative;
          display: inline-block;
          margin-left: 33px;
          margin-top: 30px;
          transition: all 0.3s;

          .resource-title {
            color: #ff5c00;
            font-family: "PingFang SC";
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: 22px; /* 110% */

            position: absolute;
            bottom: 92px;
            left: 29px;
          }

          .resource-subtitle {
            position: absolute;
            bottom: 63px;
            left: 29px;

            color: #ff5c00;
            font-family: "PingFang SC";
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px; /* 137.5% */
          }
          .resource-subscript {
            position: absolute;
            bottom: 111px;
            left: 224px;
            width: 110px;
            color: #000;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 12px; /* 100% */
          }
          .to-see {
            background: #007a94;
            position: absolute;
            bottom: 14px;
            left: 28px;
            width: 94px;
            height: 26px;
            border-radius: 31px;
            color: #fff;
            font-size: 16px;
            font-weight: 400;
            line-height: 26px;
            text-align: center;
          }

          img {
            width: 338px;
            height: 135px;
          }
          &:hover {
            cursor: pointer;
            transform: translateY(-10px);
          }
        }
      }
    }
  }
}

.silent-writing-ancient-poetry {
  background: #e1f8ff;
  height: 646px;
  width: 100%;
  position: relative;

  .content {
    width: 1194px;
    height: 526px;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;

    .title {
      width: 464px;
      height: 72px;
      flex-shrink: 0;
      margin: 0px auto 0px;
      text-align: center;

      .main-title {
        color: #007a94;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 36px;
        font-style: normal;
        font-weight: 600;
        line-height: 36px; /* 100% */
      }

      .sub-title {
        margin-top: 20px;
        color: #000;
        font-family: "PingFang SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px; /* 100% */
      }
    }

    .resource-list {
      width: 1194px;
      height: 418px;
      flex-shrink: 0;
      background-color: #fff;
      border-radius: 20px;
      margin: 30px auto 60px;
      box-shadow: 0px 4px 4px 0px rgba(225, 196, 124, 0.5);
      position: relative;

      .resource-content {
        padding-left: 27px;
        padding-top: 30px;

        .resource {
          position: relative;
          display: inline-block;
          margin-left: 33px;
          margin-top: 30px;

          transition: all 0.3s;
          &:hover {
            cursor: pointer;
            transform: translateY(-10px);
          }

          .resource-title {
            color: #044f9c;
            font-family: "PingFang SC";
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: 22px; /* 110% */

            position: absolute;
            bottom: 92px;
            left: 29px;
          }

          .resource-subtitle {
            position: absolute;
            bottom: 63px;
            left: 29px;

            color: #044f9c;
            font-family: "PingFang SC";
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px; /* 137.5% */
          }
        }
      }
    }
  }
}

.checked {
  background: #007a94;
  color: #fff;

  &:hover {
    cursor: pointer;
  }
}

.unchecked {
  background: #dbf7b6;
  color: #007a94;
  &:hover {
    cursor: pointer;
  }
}

.side {
  position: fixed;
  right: 10px;
  top: 40%;

  div {
    width: 120px;
    color: #007a94;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px; /* 178.571% */
    position: absolute;
    cursor: pointer;
    left: 5px;

    &:hover {
      color: #a6ecff;
    }
  }

  .title-1 {
    bottom: 131px;
  }
  .title-2 {
    bottom: 97px;
  }
  .title-3 {
    bottom: 64px;
  }
  .bar {
    width: 140px;
  }
  .back {
    position: absolute;
    bottom: 21px;
    left: 23px;
    cursor: pointer;
  }

  .side-checked {
    background: #007a94;
    border-radius: 5px;

    color: #fff;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    &:hover {
      color: #fff;
    }
  }
}
</style>
